'use client';
import { sendOnbEvent } from '@/components/newRelic';
import { pushFlowData } from '@/redux/flowSlice';
import { pushErrorReason } from '@/redux/navigationSlice';
import { RootState } from '@/redux/store';
import { getInstance } from '@repo/onb-api';
import { ResultScreen, useOnlineStatus } from '@repo/ui';
import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function IdentityVerificationPending(): React.JSX.Element {
  const instanceId = useSelector((state: RootState) => state.flowdata.id);
  const router = useRouter();
  const dispatch = useDispatch();
  const online = useOnlineStatus();
  const iteration = useRef(0);

  // Polls the instance every 5s until the step changes; pauses while offline so a dropped connection
  // doesn't burn the 40 attempts and end in the "slow service" error
  useEffect(() => {
    if (!online || !instanceId) return;
    let done = false;
    const interval = setInterval(async () => {
      iteration.current += 1;
      if (iteration.current > 40) {
        done = true;
        clearInterval(interval);
        sendOnbEvent({
          type: 'error',
          subtype: 'metamap',
          severity: 'high',
          data: { stepName: 'IDENTITY_VERIFICATION_STATUS_PENDING', reason: 'timeout' },
        });
        dispatch(pushErrorReason('slowService'));
        router.push('/error');
        return;
      }
      const instanceData = await getInstance({ instanceId });
      if (done) return;
      if (instanceData?.steps?.[instanceData?.steps?.length - 1]?.name !== 'IDENTITY_VERIFICATION_STATUS_PENDING') {
        done = true;
        clearInterval(interval);
        dispatch(pushFlowData(instanceData));
      }
    }, 5000);
    return () => {
      done = true;
      clearInterval(interval);
    };
  }, [online, instanceId, dispatch, router]);

  return <ResultScreen status="validating" title="Estamos verificando tu identidad, por favor esperá" />;
}
